import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import useExportHistory from '@src/hooks/useExportHistory';
import ExportHistoryEmpty from './ExportHistoryEmpty';
import ExportHistoryItem from './ExportHistoryItem';
import {
  StyledExportHistoryList,
  StyledExportHistoryLoading,
} from './index.style';

// Distance from the end of the list that asks for the next page — one row step.
const LOAD_MORE_OFFSET = 80;

const ExportHistoryTab = () => {
  const location = useLocation();
  // Same source as the four export buttons in this header.
  const projectId = location.pathname.split('/')[2];
  const audioType = useSelector((state) => state.project.audioType);

  // Mounted only while the tab is open, so the request stops as soon as the
  // user switches tab or closes the popover.
  const { items, isLoading, isLoadingMore, hasMore, loadMore } =
    useExportHistory({ projectId, enabled: true });

  const handleScroll = (event) => {
    if (!hasMore || isLoadingMore) return;
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight - LOAD_MORE_OFFSET) loadMore();
  };

  if (isLoading)
    return (
      <StyledExportHistoryLoading>
        <CircularProgress size={24} />
      </StyledExportHistoryLoading>
    );

  if (!items.length) return <ExportHistoryEmpty />;

  return (
    <StyledExportHistoryList onScroll={handleScroll}>
      {items.map((item) => (
        <ExportHistoryItem key={item.id} item={item} audioType={audioType} />
      ))}
      {isLoadingMore && (
        <div className="load-more-loading">
          <CircularProgress size={20} />
        </div>
      )}
    </StyledExportHistoryList>
  );
};

export default ExportHistoryTab;
